/**
 * Vuex module for navigation state management
 */

import { 
  getSidebarNavigation, 
  getHeaderNavigation, 
  isRouteAccessible 
} from '@/config/navigation';

const state = {
  sidebarItems: [],
  headerItems: [],
  openSections: JSON.parse(localStorage.getItem('openSections') || '{}')
};

const getters = {
  sidebarNavigation: state => state.sidebarItems,
  headerNavigation: state => state.headerItems,
  isSectionOpen: (state) => (sectionId) => {
    return !!state.openSections[sectionId];
  },
  canAccessRoute: (state, getters, rootState, rootGetters) => (route) => {
    const userRoles = rootGetters.userRoles || [];
    return isRouteAccessible(route, userRoles);
  }
};

const mutations = {
  SET_SIDEBAR_NAVIGATION(state, items) {
    state.sidebarItems = items;
  },
  
  SET_HEADER_NAVIGATION(state, items) {
    state.headerItems = items;
  },
  
  TOGGLE_SECTION(state, sectionId) {
    state.openSections[sectionId] = !state.openSections[sectionId];
    localStorage.setItem('openSections', JSON.stringify(state.openSections));
  },
  
  SET_SECTION_STATE(state, { sectionId, isOpen }) {
    state.openSections[sectionId] = isOpen;
    localStorage.setItem('openSections', JSON.stringify(state.openSections));
  },
  
  CLEAR_OPEN_SECTIONS(state) {
    state.openSections = {};
    localStorage.removeItem('openSections');
  }
};

const actions = {
  updateNavigation({ commit, rootGetters }) {
    const userRoles = rootGetters.userRoles || [];
    const isAuthenticated = rootGetters.isAuthenticated;
    
    console.log('[Navigation] Updating navigation:', {
      userRoles,
      isAuthenticated,
      hasRoles: userRoles.length > 0
    });
    
    // Update sidebar navigation
    const userPermissions = rootGetters.userPermissions || [];
    const sidebarItems = getSidebarNavigation(userRoles, isAuthenticated, userPermissions);
    console.log('[Navigation] Sidebar items after filter:', sidebarItems);
    commit('SET_SIDEBAR_NAVIGATION', sidebarItems);
    
    // Update header navigation
    const headerItems = getHeaderNavigation(userRoles, isAuthenticated);
    console.log('[Navigation] Header items after filter:', headerItems);
    commit('SET_HEADER_NAVIGATION', headerItems);
  },
  
  toggleSection({ commit }, sectionId) {
    commit('TOGGLE_SECTION', sectionId);
  },
  
  setSectionState({ commit }, { sectionId, isOpen }) {
    commit('SET_SECTION_STATE', { sectionId, isOpen });
  },
  
  clearOpenSections({ commit }) {
    commit('CLEAR_OPEN_SECTIONS');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};